module.exports = __webpack_public_path__ + "img/selectProductBg.684428db.png";